import { Body, Heading } from 'components/text';
import { CloseIcon, LittleEmperorsIcon } from 'components/icons';
import { colorConstants } from 'data/constants';
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
} from '@mui/material';

import styles from './Modal.module.scss';
import { ModalProps } from './types';

const Modal: React.FC<ModalProps> = ({
  isOpen = false,
  onClose,
  shouldSendLater,
}) => {
  return (
    <Dialog
      open={isOpen}
      className={styles.modal}
      fullWidth
      PaperProps={PaperProps}
      onClose={onClose}
    >
      <div className={styles.container}>
        <DialogActions className={styles.actions}>
          <IconButton onClick={onClose}>
            <CloseIcon className={styles.closeIcon} />
          </IconButton>
        </DialogActions>
        <DialogContent className={styles.content}>
          <LittleEmperorsIcon color={colorConstants.black} />
          <Heading as="h4">Thank you</Heading>
          <Heading as="h5">
            Your e-gift card{' '}
            {shouldSendLater ? 'will be sent as scheduled' : 'has been sent'}
          </Heading>
          <Body>You will receive a confirmation email soon</Body>
        </DialogContent>
      </div>
    </Dialog>
  );
};

const PaperProps = {
  sx: {
    maxWidth: '540px',
    margin: 0,
    width: '100%',
    borderRadius: 0,
  },
};

export default Modal;
